/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

/**
 * Feedback collection and suggestion conversion metrics for a skill.
 */
export type SkillFeedbackMetrics = {
  /**
   * Resolved skill activations during the collection window.
   */
  activationsInWindow: number;
  /**
   * All-time feedback linked to a generated suggestion.
   */
  converted: number;
  /**
   * Resolved activations paired to feedback during the collection window.
   */
  feedbackActivationsInWindow: number;
  /**
   * Feedback recorded during the collection window.
   */
  feedbackInWindow: number;
  /**
   * Feedback not yet reviewed by suggestion analysis.
   */
  unreviewed: number;
  /**
   * The end of the rolling collection window.
   */
  windowEnd: Date;
  /**
   * The start of the rolling collection window.
   */
  windowStart: Date;
};

/** @internal */
export const SkillFeedbackMetrics$inboundSchema: z.ZodMiniType<
  SkillFeedbackMetrics,
  unknown
> = z.pipe(
  z.object({
    activations_in_window: z.int(),
    converted: z.int(),
    feedback_activations_in_window: z.int(),
    feedback_in_window: z.int(),
    unreviewed: z.int(),
    window_end: z.pipe(
      z.iso.datetime({ offset: true }),
      z.transform(v => new Date(v)),
    ),
    window_start: z.pipe(
      z.iso.datetime({ offset: true }),
      z.transform(v => new Date(v)),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      "activations_in_window": "activationsInWindow",
      "feedback_activations_in_window": "feedbackActivationsInWindow",
      "feedback_in_window": "feedbackInWindow",
      "window_end": "windowEnd",
      "window_start": "windowStart",
    });
  }),
);

export function skillFeedbackMetricsFromJSON(
  jsonString: string,
): SafeParseResult<SkillFeedbackMetrics, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => SkillFeedbackMetrics$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'SkillFeedbackMetrics' from JSON`,
  );
}
